export let OAUTH_CLIENT_ID = process.env.OAUTH_CLIENT_ID
export let API_KEY = process.env.API_KEY




// WEBPACK FOOTER //
// ./src/config.js